import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { EMPLOYEE_TRAKING_API } from "../constants/constants";
import { defaultErrorMsg, defaultHeaders } from "../utils/params";

export const visitServiceApi = createApi({
  reducerPath: "visitServiceApi",
  baseQuery: async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: EMPLOYEE_TRAKING_API,
      prepareHeaders: async (headers, { getState }) => {
        const token = (getState() as any)?.auth?.access_token;

        return defaultHeaders(headers, token);
      },
    });

    const result = await baseQuery(args, api, extraOptions);

    await defaultErrorMsg(result);

    return result;
  },
  tagTypes: ["GetTrackingSetting", "GetTrackingEmployeeList"],
  keepUnusedDataFor: 2,
  endpoints: () => ({}),
});
